'use strict';

window.jQuery = require('jquery');
window.$ = require('jquery');

// New scripts - nodejs packages
require('select2');
require('owl.carousel');

// Utility includes
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('base/components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('base/components/toolTip'));

    // New scripts - components
    processInclude(require('libFrontendComponents/components/carousel'));
    processInclude(require('libFrontendComponents/components/select'));
    processInclude(require('libFrontendComponents/components/datepicker'));
    processInclude(require('storeContext/components/storeWelcomeAlert'));
    processInclude(require('storeContext/components/modals/reviewCart'));
    processInclude(require('./components/storeSelector'));

    // New scripts - utilites
    processInclude(require('libFrontendComponents/utilities/lazyload'));

    // New scripts - product
    processInclude(require('./product/promotion'));
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./wishlist/wishlist'));
    processInclude(require('./product/quickView'));
});

// Bootstrap
require('base/thirdParty/bootstrap');

// Date picker - Include every site language script
require('bootstrap-datepicker');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.pt.min.js');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.en-GB.min.js');

// Override scripts - from app_storefront_base cartridge
require('libFrontendComponents/components/spinner');

// New scripts - utilities (jquery)
require('libFrontendComponents/utilities/viewport');
require('libFrontendComponents/utilities/globalVars');

// New scripts - components (jquery)
require('./components/alert');
